import React from 'react'

const NoAccountCart = () => {
  return (
    <>
      <div className='flex flex-col justify-center items-center text-[20px] my-[20vh] md:text-[40px]'>
        <img src={require('../../Images/cart3.png')} alt="" className='shadow-lg'/>
        <div className='my-[20px] shadow-sm'>Login to add items to cart!</div>
      </div>
    </>
  )
}

export default NoAccountCart
